/**
 * Created by JackCui on 2021/12/2
 */

import render from './render.vue'
import pageRender from './page-render.vue'
import popupRender from './popup-render.vue'
import groupRender from './group-render.vue'
import formRender from './form-render.vue'
import formItemRender from './form-item-render.vue'
import tabsRender from './tabs-render.vue'
import headerRender from './header-render.vue'
import footerRender from './footer-render.vue'
import tabItemRender from './tab-item-render.vue'
import tableRender from './table-render.vue'
import buttonsRender from './buttons-render.vue'
import filterRender from './filter-render.vue'
import filterItemRender from './filter-item-render.vue'
import summaryRender from './summary-render.vue'
import fieldGroupRender from './field-group-render.vue'
import tipRender from './tip-render.vue'

export default {
  render,
  pageRender,
  popupRender,
  groupRender,
  formRender,
  tabsRender,
  headerRender,
  footerRender,
  tableRender,
  buttonsRender,
  formItemRender,
  tabItemRender,
  filterRender,
  filterItemRender,
  summaryRender,
  fieldGroupRender,
  tipRender
}
